import React from 'react';
import './ReportCard.css';

const GRADING_SCALE = [
    { range: '75-100', grade: 'A1', remark: 'Distinction' },
    { range: '70-74', grade: 'B2', remark: 'Excellent' },
    { range: '65-69', grade: 'B3', remark: 'Very Good' },
    { range: '60-64', grade: 'C4', remark: 'Good' },
    { range: '55-59', grade: 'C5', remark: 'Credit' },
    { range: '50-54', grade: 'C6', remark: 'Credit' },
    { range: '45-49', grade: 'D7', remark: 'Pass' },
    { range: '40-44', grade: 'E8', remark: 'Pass' },
    { range: '0-39', grade: 'F9', remark: 'Fail' },
];

const getGradeDetails = (total) => {
    for (const scale of GRADING_SCALE) {
        const [min, max] = scale.range.split('-').map(Number);
        if (total >= min && total <= max) {
            return { grade: scale.grade, remark: scale.remark };
        }
    }
    return { grade: 'N/A', remark: 'N/A' };
};

const ReportSheet = ({ student, scores, term, session, schoolInfo, traits, formMasterName, gradingStructure, subjectDetails, students }) => {

    const subjects = Object.keys(scores);

    return (
        <div className="report-sheet-container">
            <div className="report-card-page">
                <table style={{ width: '100%', borderCollapse: 'collapse' }} border="0">
                    <tbody>
                        <tr>
                            <td style={{ width: '20%', verticalAlign: 'top' }} rowSpan="4">
                                <img src={schoolInfo?.logoUrl || "/img/logo-placeholder.png"} width="100" height="100" alt="School Logo"/>
                            </td>
                            <td style={{ textAlign: 'center', fontFamily: "'Arial Black', sans-serif", color: '#236fa1', fontSize: '24pt' }} colSpan="2"><strong>{schoolInfo?.schoolName}</strong></td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'center', color: '#e03e2d'}} colSpan="2"><strong><em>({schoolInfo?.motto})</em></strong></td>
                        </tr>
                            <tr>
                            <td style={{ textAlign: 'center', color: '#e03e2d'}} colSpan="2"><strong>{schoolInfo?.address}</strong></td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'center', color: '#3598db'}}><strong>{schoolInfo?.phone}</strong></td>
                            <td style={{ textAlign: 'right', color: '#3598db'}}><strong>{schoolInfo?.email}</strong></td>
                        </tr>
                    </tbody>
                </table>
                <hr/>
                <div style={{ textAlign: 'center', textDecoration: 'underline', color: '#236fa1', fontWeight: 'bold'}}>
                    Terminal Progress Report for {term}, {session} session
                </div>

                <table style={{ width: '100%', marginTop: '1rem' }} border="0">
                    <tbody>
                        <tr>
                            <td colSpan="2"><strong>Name of Student:</strong> <span style={{ fontFamily: "'Arial Black', sans-serif"}}>{student.fullName || student.name}</span></td>
                            <td><strong>Days school opened:</strong> {student.daysOpened || 'N/A'}</td>
                            <td rowSpan="3" style={{verticalAlign: 'top'}}><img width="100" height="100" style={{borderRadius: '50%'}} src={student.photoURL || 'https://via.placeholder.com/100'} alt="student"/></td>
                        </tr>
                        <tr>
                            <td><strong>Admission No:</strong> {student.studentId}</td>
                            <td><strong>Sex:</strong> {student.gender}</td>
                            <td><strong>Days present:</strong> {student.daysPresent || 'N/A'}</td>
                        </tr>
                            <tr>
                            <td><strong>Class:</strong> {student.class || student.studentClass}</td>
                            <td><strong>No. in Class:</strong> {students.length}</td>
                            <td><strong>Position:</strong> {student.position}</td>
                        </tr>
                    </tbody>
                </table>

                <div style={{color: '#3598db', fontFamily: "'Comic Sans MS', sans-serif", fontWeight: 'bold', marginTop: '1rem'}}>COGNITIVE DOMAIN</div>
                <table className="table table-bordered table-striped table-sm mt-2">
                    <thead>
                        <tr>
                            <th>Subject</th>
                            {Object.keys(gradingStructure).map(ca => <th key={ca}>{ca} ({gradingStructure[ca]}%)</th>)}
                            <th>Total</th>
                            <th>Grade</th>
                            <th>Class Avg</th>
                            <th>Remark</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subjects.map(subject => {
                            const subjectScores = scores[subject] || {};
                            const subjectTotal = Object.values(subjectScores).reduce((a, s) => a + (Number(s) || 0), 0);
                            const { grade, remark } = getGradeDetails(subjectTotal);
                            return (
                                <tr key={subject}>
                                    <td>{subject}</td>
                                    {Object.keys(gradingStructure).map(ca => <td key={ca}>{subjectScores[ca] || 0}</td>)}
                                    <td>{subjectTotal}</td>
                                    <td>{grade}</td>
                                    <td>{subjectDetails[subject]?.classAverage.toFixed(2) || 'N/A'}</td>
                                    <td>{remark}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                    <table style={{width: '100%', marginTop: '1rem', border: '1px solid black', padding: '0.5rem'}}>
                    <tbody>
                        <tr>
                            <td><strong>Total Score:</strong> <span style={{color: '#e03e2d'}}>{student.totalScore.toFixed(2)}</span></td>
                            <td><strong>Average:</strong> <span style={{color: '#e03e2d'}}>{student.average.toFixed(2)}</span></td>
                            <td><strong>Position:</strong> <span style={{color: '#e03e2d'}}>{student.position}</span></td>
                        </tr>
                    </tbody>
                </table>

                <hr />

                <table style={{width: '100%'}}>
                    <tbody>
                        <tr>
                            <td style={{width: '50%'}}>
                                <div style={{color: '#e03e2d', fontWeight: 'bold'}}>RATING</div>
                                <table className="table-tiny table-striped small">
                                    <tbody>
                                        <tr><td colSpan="2"><strong>Psychomotor Skills</strong></td></tr>
                                        {traits?.psychomotor && Object.keys(traits.psychomotor).map(skill => (
                                            <tr key={skill}><td>{skill}</td><td>{traits.psychomotor[skill]}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                                    <table className="table-tiny table-striped small mt-2">
                                    <tbody>
                                        <tr><td colSpan="2"><strong>Affective Areas</strong></td></tr>
                                        {traits?.affective && Object.keys(traits.affective).map(area => (
                                            <tr key={area}><td>{area}</td><td>{traits.affective[area]}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                            </td>
                            <td style={{width: '50%', verticalAlign: 'top'}}>
                                <div style={{color: '#e03e2d', fontWeight: 'bold'}}>GRADING SCALE</div>
                                <table className="table-tiny table-striped small">
                                    <tbody>
                                        {GRADING_SCALE.map(scale => (
                                            <tr key={scale.grade}><td>{scale.grade}</td><td>{scale.range}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <hr />
                <table style={{width: '100%'}}>
                    <tbody>
                        <tr>
                            <td><strong>Class master's name:</strong></td>
                            <td><span style={{fontFamily: "'Comic Sans MS', sans-serif"}}>{formMasterName}</span></td>
                            <td></td>
                        </tr>
                            <tr>
                            <td><strong>Class master's remark:</strong></td>
                            <td>{traits?.teacherRemark || 'N/A'}</td>
                            <td></td>
                        </tr>
                            <tr>
                            <td><strong>Principal's remark:</strong></td>
                            <td>{traits?.principalRemark || 'N/A'}</td>
                            <td style={{textAlign: 'center'}}>________________</td>
                        </tr>
                            <tr>
                            <td><strong>Term ends:</strong> {student.termEnd || 'N/A'}</td>
                            <td><strong>Next term begins:</strong> {student.nextTermStart || 'N/A'}</td>
                            <td style={{textAlign: 'center'}}><strong>Signature</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ReportSheet;
